/**
 * Bundle market translations
 * Manages dynamic text translation across multiple markets
 */

class BundleMarketTranslations {
  constructor() {
    this.bundleForm = null;
    this.isInitialized = false;
    this.translations = this.getTranslations();

    document.addEventListener("BiscuitsBundleForm:ready", (event) => {
      this.bundleForm = event.target;
      this.init();
    });
  }

  getTranslations() {
    const translations = {
      en: {
        Zwischensumme: {
          selector: ".biscuits-bundle-totals__row--compare .biscuits-bundle-totals__text",
          text: "Subtotal",
        },
        Rabatt: {
          selector: ".biscuits-bundle-totals__row--discount .biscuits-bundle-totals__text",
          text: "Discount",
        },
        Gesamt: {
          selector: ".biscuits-bundle-totals__row--total .biscuits-bundle-totals__text",
          text: "Total",
        },
        Erforderlich: {
          selector: "[data-biscuits-step=\"1\"] .biscuits-bundle-step__required",
          text: "Required",
        },
        errorStep1: {
          selector: ".biscuits-bundle-form__messages--error .biscuits-error--review-step-1-error",
          text: "Please check step 1",
          observer: true,
        },
        errorSelectable: {
          selector: ".biscuits-bundle-step__messages .biscuits-error--minimum-selectable-error",
          text: "Choose at least 1",
          observer: true,
        },
        errorQuantity: {
          selector: ".biscuits-bundle-step__messages .biscuits-error--minimum-quantity-error",
          text: "Choose at least 2 products",
          observer: true,
        },
      },
    };

    return translations.en;
  }

  applyTranslations() {
    Object.values(this.translations).forEach((entry) => {
      if (entry.observer) {
        return;
      }
      const el = document.querySelector(entry.selector);
      if (el && entry.text) {
        el.textContent = entry.text;
      }
    });
  }

  init() {
    if (this.isInitialized || !this.bundleForm) return;

    this.applyTranslations();
    this.setupObserver();
    this.isInitialized = true;
  }

  setupObserver() {
    if (!this.bundleForm) return;

    // Filter translations that require Observer
    const dynamicEntries = Object.values(this.translations).filter(
      (entry) => entry.observer
    );

    if (dynamicEntries.length === 0) return;

    // Selecting a parent element for tracking
    const targetNode = this.bundleForm;
    const config = {
      childList: true,
      subtree: true,
      attributes: true
    };

    // Callback for Observer: checking all dynamic selectors
    const callback = () => {
      dynamicEntries.forEach((entry) => {
        const element = targetNode.querySelector(entry.selector);
        if (element && entry.text && element.textContent !== entry.text) {
          element.textContent = entry.text;
        }
      });
    };

    // Initialization of a single Observer for all dynamic elements
    this.observer = new MutationObserver(callback);
    this.observer.observe(targetNode, config);

    callback();
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

window.bundleMarketTranslations = new BundleMarketTranslations();